import React from "react";
import ImgBackground from "../components/pngBackground/imageBackground";
import ContactUsImg from "../assets/images/contactUs.png";
import "./styles.scss"
import TestimonialsTravala from "../components/testimonialsTravala/testimonialTravala";
const TestimonialsPage = () => {
  return (
    <div className="main-layout-container ">
      <ImgBackground insideText={"Testimonials"} imgPath={ContactUsImg} />
      <TestimonialsTravala />
    </div>
  );
};

export default TestimonialsPage;
